import { render, staticRenderFns } from "./pengajuanDetail.vue?vue&type=template&id=319ca35d&scoped=true"
import script from "./pengajuanDetail.vue?vue&type=script&lang=js"
export * from "./pengajuanDetail.vue?vue&type=script&lang=js"
import style0 from "./pengajuanDetail.vue?vue&type=style&index=0&id=319ca35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ca35d",
  null
  
)

export default component.exports